import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HCE_ESTADOS, HCE_TIPOTURNOS } from '../../../utils/constants';
import { LocalHospitalSharp, VideoCallSharp } from '@material-ui/icons';
import { ModalHce } from './ModalHce/ModalHce';
import {
  FetchDataAfiliadoExternoHCE,
  FetchDataAfiliadoHCE,
  TraerProblemasAfiliado,
  TraerRecordatorioGeneral,
  TraerRecordatorioPropio,
  autopercepcionClear,
  getAutopercepcionPorAfiliadoHCE,
  setHceSelec,
  traerEstadosProblemas,
} from '../../../actions/hce/hceActions';
import { IniciarChatAfiliado } from '../../../actions/hce/hceTeleconsultaActions';


const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};



export const HceItem = (props) => {

  const classes = useRowStyles();
  const dispatch = useDispatch();
  const { item, piso, consultorio, idEfectorRed, idCentroMedico, relEfectorCMEspe } = props;
  const [openModalHce, setOpenModalHce] = useState(false);

  const baseUrl = process.env.REACT_APP_URL_BASE;

  let nombre = "Medico";

  return (
    <>

      {openModalHce && (
        <ModalHce
          open={openModalHce}
          closeModalHandler={() => setOpenModalHce(false)}
          hce={item}
          piso={piso}
          consultorio={consultorio}
          idEfectorRed={idEfectorRed}
          idCentroMedico={idCentroMedico}
          disabled={false}
          relEfectorCMEspe={relEfectorCMEspe}
        />
      )}
      <TableRow className={classes.root}>
        <TableCell align="left">
          {new Date(item?.fecha).toLocaleString('es', optionsfecha)}
        </TableCell>
        <TableCell align="left">{item?.hora}</TableCell>
        <TableCell align="left">{item?.dia}</TableCell>
        <TableCell align="left">{item?.carnet}</TableCell>
        <TableCell align="left">{item?.nombreApellido}</TableCell>
        <TableCell align="left">{item?.descripcionSobreturno}</TableCell>
        <TableCell align="left">{item?.descripcionEspecialidad}</TableCell>
        <TableCell align="left">
          {item?.fechaAtencion !== null ? "SI" : ""}
        </TableCell>
        <TableCell>
          {item?.confirmado === HCE_ESTADOS.CONFIRMADOS &&
            item?.idTipoTurnoSol === HCE_TIPOTURNOS.VIDEOCONSULTA && (
              <Button
                style={{
                  fontSize: '0.8rem',
                  backgroundColor: item.fechaConexion ? 'green' : 'red',
                }}
                variant="contained"
                color="primary"
                disabled={item.fechaConexion === null ? true : false}
                onClick={() => {
                  // Construye la URL con los parámetros que deseas pasar
                  const url = `${baseUrl}/afiliado/salaTelemedicina?nombre=${nombre}&idAgenda=${item.idAgenda}`;
                  // Abre una nueva pestaña con la URL construida
                  const newTab = window.open(url, '_blank', 'noopener,noreferrer');
                  console.log(newTab)
                  const datos = {
                    idAfiliado: item.idAfiliado,
                    idEfector: item.idEfector,
                    idAgenda: item.idAgenda
                  }
                  dispatch(IniciarChatAfiliado(datos))
                }}
              >
                <VideoCallSharp />
              </Button>
            )}
        </TableCell>
        <TableCell>
          {item?.confirmado === HCE_ESTADOS.CONFIRMADOS && (
            <Button
              style={{ fontSize: '0.8rem' }}
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(
                  TraerRecordatorioGeneral(item.idAfiliado, item.idAfiliadoExterno,item.idEfector, 0),
                );
                dispatch(
                  TraerRecordatorioPropio(
                    item.idAfiliado,
                    item.idAfiliadoExterno,
                    item.idEfector,
                    1,
                    () => {
                      setOpenModalHce(true);
                    },
                  ),
                );
                if (item?.idAfiliado) {
                  dispatch(FetchDataAfiliadoHCE(item?.idAfiliado));
                }
                else {
                  dispatch(FetchDataAfiliadoExternoHCE(item?.idObraSocial, item?.nroDocumento))
                }
                dispatch(TraerProblemasAfiliado(item?.idAfiliado, item?.idAfiliadoExterno));
                if (item?.idAfiliado) {
                  dispatch(getAutopercepcionPorAfiliadoHCE(item.idAfiliado));
                }
                dispatch(traerEstadosProblemas());
                //setOpenModalHce(true);
                dispatch(setHceSelec(item));
                dispatch(autopercepcionClear());
              }}
            >
              <LocalHospitalSharp />
            </Button>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
